import { ElDialog as m, ElButton as u } from "element-plus";
import { resolveComponent as s, openBlock as n, createBlock as o, mergeProps as B, withCtx as l, createElementVNode as p, createTextVNode as r, toDisplayString as d, createCommentVNode as c, renderSlot as g } from "vue";
import { _ as x } from "../_plugin-vue_export-helper-dad06003.js";
import { w as h } from "../util-b2b0dc25.js";
const b = {
  name: "rStepDialogItem",
  components: { ElDialog: m, ElButton: u },
  props: {
    /**
     * 弹窗标识, 可用通过step-dialog组件的toStep来跳转到指定弹窗
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * 标题
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * 最后一步？
     */
    isLast: {
      type: Boolean,
      default: !1
    },
    /**
     * 第一步？
     */
    isFirst: {
      type: Boolean,
      default: !1
    },
    /**
     * 上一步按钮loading
     */
    prevBtnLoading: {
      type: Boolean,
      default: !1
    },
    /**
     * 下一步按钮loading
     */
    nextBtnLoading: {
      type: Boolean,
      default: !1
    },
    /**
     * 上一步按钮禁用
     */
    prevBtnDisabled: {
      type: Boolean,
      default: !1
    },
    /**
     * 下一步按钮禁用
     */
    nextBtnDisabled: {
      type: Boolean,
      default: !1
    },
    /**
     * 上一步按钮文本, 当值为空时，会按默认规则显示按钮文本，否则直接使用该属性值
     */
    prevBtnText: {
      type: String,
      default: ""
    },
    /**
     * 下一步按钮文本, 当值为空时，会按默认规则显示按钮文本，否则直接使用该属性值
     */
    nextBtnText: {
      type: String,
      default: ""
    },
    /**
     * 显示上一步按钮
     */
    showPrevBtn: {
      type: Boolean,
      default: !0
    },
    /**
     * 显示下一步按钮
     */
    showNextBtn: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    ghostBtnText() {
      return this.prevBtnText || (this.isFirst ? this.$t("bmui-step-dialog.cancel") : this.$t("bmui-step-dialog.previous"));
    },
    primaryBtnText() {
      return this.nextBtnText || (this.isLast ? this.$t("bmui-step-dialog.confirm") : this.$t("bmui-step-dialog.next"));
    }
  },
  emits: {
    /**
     * 点击右上角关闭回调
     */
    beforeClose: null,
    /**
     * 点击上一步按钮
     */
    prevBtnClick: null,
    /**
     * 点击下一步按钮
     */
    nextBtnClick: null
  },
  methods: {
    beforeClose() {
      this.$emit("beforeClose");
    },
    prevBtnClick() {
      this.$emit("prevBtnClick");
    },
    nextBtnClick() {
      this.$emit("nextBtnClick");
    }
  }
}, v = { class: "dialog-footer" };
function y(i, k, e, _, D, t) {
  const a = s("ElButton"), f = s("ElDialog");
  return n(), o(f, B({ class: "r-step-dialog-item" }, i.$attrs, {
    title: e.title,
    "before-close": t.beforeClose,
    "close-on-click-modal": !1
  }), {
    footer: l(() => [
      p("span", v, [
        e.showPrevBtn ? (n(), o(a, {
          key: 0,
          disabled: e.prevBtnDisabled,
          loading: e.prevBtnLoading,
          onClick: t.prevBtnClick
        }, {
          default: l(() => [
            r(
              d(t.ghostBtnText),
              1
              /* TEXT */
            )
          ]),
          _: 1
          /* STABLE */
        }, 8, ["disabled", "loading", "onClick"])) : c("v-if", !0),
        e.showNextBtn ? (n(), o(a, {
          key: 1,
          type: "primary",
          disabled: e.nextBtnDisabled,
          loading: e.nextBtnLoading,
          onClick: t.nextBtnClick
        }, {
          default: l(() => [
            r(
              d(t.primaryBtnText),
              1
              /* TEXT */
            )
          ]),
          _: 1
          /* STABLE */
        }, 8, ["disabled", "loading", "onClick"])) : c("v-if", !0)
      ])
    ]),
    default: l(() => [
      g(i.$slots, "default")
    ]),
    _: 3
    /* FORWARDED */
  }, 16, ["title", "before-close"]);
}
const C = /* @__PURE__ */ x(b, [["render", y], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/step-dialog-item/step-dialog-item.vue"]]), L = h(C);
export {
  L as default
};
